import { useEffect, useMemo, useState } from "react";
import { IFpayParams } from "@/api/apiRsp/IFWalletRsp";
import type { FormInstance } from "@/componentsUI/Form";
import { sortPaymentParams } from "@/pages/wallet/shared/PaymentMethodUtils";

export function useRechargePaymentMethod(
  payParams: IFpayParams[] | undefined,
  form: FormInstance,
  currencyType: string,
) {
  const [selection, setSelection] = useState<{ currency: string; code: string }>();
  // Store only the selection; activity rules always come from the latest response.
  const rule = useMemo(() => {
    const ordered = sortPaymentParams(payParams || []);
    return ordered.find((item) =>
      selection?.currency === currencyType && item.payCode === selection.code
    ) || ordered[0];
  }, [currencyType, payParams, selection]);

  useEffect(() => {
    const previous = form.getFieldValue("payType");
    if (previous && previous.data?.payCode !== rule?.payCode) {
      form.setFieldValue("amount", undefined);
    }
    form.setFieldValue("payType", rule ? { type: rule.payName, data: rule } : undefined);
    if (rule && (selection?.currency !== currencyType || selection?.code !== rule.payCode)) {
      setSelection({ currency: currencyType, code: rule.payCode });
    }
  }, [currencyType, form, rule, selection]);

  const changeType = (value: { type: string; data?: IFpayParams }) => {
    const next = payParams?.find((item) =>
      value.data?.payCode ? item.payCode === value.data.payCode : item.payName === value.type
    );
    if (next) {
      if (next.payCode !== rule?.payCode) form.setFieldValue("amount", undefined);
      setSelection({ currency: currencyType, code: next.payCode });
    }
  };

  return { rule, changeType };
}
